const mediaSettingsSelector = (state) => state.mediaSettings;

export default mediaSettingsSelector;